import React, { useState, useEffect } from "react";
import axios from "axios";
import ForecastWeather from "./ForecastWeather";

export default function Forecast(props) {
  const [forecast, setForecast] = useState(null);

  const apiKey = "40o03736bbe0e6faa9b79f5dt4af0a0f";

  function displayForecast(response) {
    setForecast(response.data.daily);
  }

  useEffect(() => {
    const forecastApiUrl = `https://api.shecodes.io/weather/v1/forecast?query=${props.city}&key=${apiKey}&units=metric`;
    axios.get(forecastApiUrl).then(displayForecast);
  }, [props.city]);

  function getForecastInfo() {
    if (forecast) {
      return forecast.map(function (dailyForecast, index) {
        if (index < 5) {
          return (
            <div className="daily-forecast" key={index}>
              <ForecastWeather
                forecast={dailyForecast}
                unit={props.unit}
                setUnit={props.setUnit}
              />
            </div>
          );
        }

        return null;
      });
    } else {
      return null;
    }
  }

  return <div className="forecast">{getForecastInfo()}</div>;
}
